export default __webpack_public_path__ + "assets/img/aww-logo-small.28dec215e1a34ac56a0a3967398cf38f.svg";